const { BASE_URL } = require("./client");

const GET_ALL_EMAILS = BASE_URL + "/api/track";
const RESEND_EMAIL = BASE_URL + "/api/track/resend-email";

export { GET_ALL_EMAILS, RESEND_EMAIL };
